<template>
  <div>
    <v-btn icon @click="openDialog()">
      <v-icon :color="ui.btnColor">
        {{item.btnIcon}}
      </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon left :color="ui.btnColor">
              {{item.btnIcon}}
            </v-icon>
            <span :class="ui.textTitle">
              {{item.title}}
            </span>
            <v-spacer/>
            <span :class="ui.textTitle">
              {{displayDocumentIDGTypeA(getDetailBasic.tag, getDetailBasic.idg)}}
            </span>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text>
          <v-layout row>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{item.icon}}</v-icon>
                </v-avatar>
              </v-chip>
            </span>
            <v-spacer/>
          </v-layout>
          <v-layout row v-if="this.getDetail.basic.id !== ''">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>title</v-icon>
                </v-avatar>
                {{getDetail.basic.title}}
              </v-chip>
            </span>
          </v-layout>
          <v-layout row v-if="this.getDetail.basic.id !== ''">
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>sell</v-icon>
                </v-avatar>
                {{getDetail.basic.id}}
              </v-chip>
            </span>
            <v-spacer/>
            <span :class="ui.textSubheading">
              <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
                <v-avatar>
                  <v-icon>{{item.transIcon}}</v-icon>
                </v-avatar>
                {{item.transTitle}}
              </v-chip>
            </span>
          </v-layout>
          <v-layout class="mt-4">
            <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
              <v-avatar>
              <v-icon> text_snippet </v-icon>
              </v-avatar>
              Document Active Status
            </v-chip>
            <v-spacer/>
          </v-layout>
          <v-layout class="ml-3 mr-3 mt-1">
            <div :class="item.textareaModel">
              {{item.message}}
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            close
          </v-btn>
          <v-spacer/>
          <v-btn
          @click="updateFormBasic" :color="ui.btnColor" flat>
            <v-icon left> {{item.btnIcon}} </v-icon>
            {{item.title}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";

export default {
  mixins: [
    apptheme,
    dateFunctions,
    numberFunctions,
    describeDocument,
    displayFunctions,
    docRevsModFunctions
  ],
  data() {
    return {
      dialog: false,
      valid: false
    };
  },
  computed: {
    ...mapGetters(["getDetail", "getDetailBasic"]),
    tag() {
      let tag = this.getDetail.basic.tag;
      return tag;
    },
    item() {
      let obj = {
        title: "",
        btnIcon: "",
        transTitle: "",
        transIcon: "",
        message: ""
      };
      if (this.getDetail.trans !== null && this.getDetail.trans !== undefined) {
        // eslint-disable-next-line
        obj.transTitle = this.getDetail.trans.flow[this.getDetail.trans.flow.length - 1].title;
        // eslint-disable-next-line
        obj.transIcon = this.getDetail.trans.flow[this.getDetail.trans.flow.length - 1].icon;
      }

      if (this.getDetailBasic.act === true) {
        obj.btnIcon = "lock";
        obj.title = "Lock";
        // eslint-disable-next-line
        obj.message = "Disable the document to suspend or supersede the document due to out of date information or licence limits.";
      } else {
        obj.btnIcon = "lock_open";
        obj.title = "Unlock";
        // eslint-disable-next-line
        obj.message = "Enable the document for business operation, the document will likely required a commercial or technical review prior to redistribution.";
      }

      // others
      return obj;
    }
  },
  // eslint-disable-next-line
  props: {
    listIndex: {
      type: Number
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    updateFormBasic() {
      let basic = this.getDetailBasic;
      let act = null;
      if (basic.act === true) {
        act = false;
      } else {
        act = true;
      }
      basic.act = act;
      this.$store.dispatch("changeDetailBasic", basic);
      this.saveDocumentRevMod(3.11, 1); // business mod.
      this.$store.dispatch("changeDataSavePendingIndication", true);
      this.dialog = false;
    }
  }
};
</script>
